module.exports = __webpack_public_path__ + "static/media/b_files.ae721302.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/b_files.svg
// module id = 2702
// module chunks = 0